import { render, staticRenderFns } from "./BindDialog.vue?vue&type=template&id=66ad3b98"
import script from "./BindDialog.vue?vue&type=script&lang=js"
export * from "./BindDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports